import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryFilterComponent } from './category-filter.component';
import { TreeModule } from "primeng/primeng";

@NgModule({
  imports: [
    CommonModule,
    TreeModule
  ],
  declarations: [CategoryFilterComponent],
  exports: [
    CategoryFilterComponent
  ]
})
export class CategoryFilterModule { }



// WEBPACK FOOTER //
// ./src/app/category-filter/category-filter.module.ts